export default __webpack_public_path__ + "static/media/open.2e1873f8.svg";